export enum RulesEnum{
  DEFAULT_RULE='0'
}
